import { useEffect, useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { SNativeVideoPlayer } from './styled';
import { NativeVideoPlayerProps } from './types';

export const NativeVideoPlayer = ({ controls = true, ...rest }: NativeVideoPlayerProps) => {
  const [ref, setRef] = useState<HTMLVideoElement | null>(null);
  const { isMobile } = useDeviceType();

  useEffect(() => {
    if (!ref || !isMobile) return;

    const observer = new IntersectionObserver(
      ([video]) => {
        if (video.isIntersecting) {
          setTimeout(() => {
            ref?.load();
          }, 500);

          observer.disconnect();
        }
      },
      {
        threshold: 0.5,
      },
    );

    observer.observe(ref);

    return () => observer.disconnect();
  }, [ref, isMobile]);

  return (
    <SNativeVideoPlayer
      component="video"
      controls={controls}
      controlsList="noplaybackrate nodownload"
      // @ts-expect-error valid
      ref={setRef}
      disablePictureInPicture
      muted
      playsInline
      {...rest}
    />
  );
};
